import { render, staticRenderFns } from "./SyncStateOrders.vue?vue&type=template&id=adcb38f2&scoped=true&"
import script from "./SyncStateOrders.vue?vue&type=script&lang=js&"
export * from "./SyncStateOrders.vue?vue&type=script&lang=js&"
import style0 from "./SyncStateOrders.vue?vue&type=style&index=0&id=adcb38f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adcb38f2",
  null
  
)

export default component.exports